<template>
  <div class="jc-trafficInfo-container">
    <!-- 基本信息  -->
    <div class="el-section">
      <div class="el-section-header">
        <h3 class="el-section-title">{{$t('merge.basicInfo')}}</h3>
      </div>
      <div class="el-section-content">
        <div class="base-info">
          <div class="base-info-item">
            <div class="item"
                 :title="trafficInfo.bandwidthName">{{$t('bwTraffic.name')}}：
              {{trafficInfo.bandwidthName | maybeEmpty}} </div>
            <div class="item"
                 :title="trafficInfo.totalTrafficIn">{{$t('bwTraffic.totalUpRealTraffic')}}：{{trafficInfo.totalTrafficIn
              | falseData}}
            </div>
            <div class="item"
                 :title="trafficInfo.totalTrafficOut">{{$t('bwTraffic.totalDownRealTraffic')}}：{{trafficInfo.totalTrafficOut
              | falseData}}
            </div>
          </div>
          <div class="base-info-item">
            <div class="item"
                 :title="trafficInfo.bandwidth">{{$t('bwTraffic.totalBandwidth')}}：{{trafficInfo.bandwidth
              | falseData}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 交换机信息 -->
    <div class="el-section">
      <div class="el-section-header">
        <h3 class="el-section-title">{{$t('bwTraffic.switchInfo')}}</h3>
      </div>
      <div class="el-section-content">
        <el-table :data="trafficInfo.switchboard"
                  style="width: 100%"
                  ref="filterTable"
                  @filter-change="filterChange">
          <el-table-column :label="$t('bwTraffic.switchIP')"
                           prop="ip"></el-table-column>
          <el-table-column :label="$t('bwTraffic.port')"
                           prop="port"></el-table-column>
          <el-table-column :label="$t('bwTraffic.upRealTraffic')">
            <template slot-scope="scope">
              <span>{{scope.row.trafficIn | falseData}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('bwTraffic.downRealTraffic')">
            <template slot-scope="scope">
              <span>{{scope.row.trafficOut | falseData}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="alarmStatus"
                           :filter-multiple="false"
                           :filters="alarmStatusFilters"
                           :filter-method="filtersMethod"
                           :label="$t('alarmHistory.alarmStatus')">
            <template slot-scope="scope">
              <span :class="{'jc-status jc-status--red':scope.row.alarmStatus===2,'jc-status jc-status--green': true} ">
                {{scope.row.alarmStatusName}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="filterEmptyFlag"
             class="el-table__empty-block my-table-empty-block">
          <span class="el-table__empty-text">{{$t('text.hasSearch')}}</span></div>
      </div>
    </div>
    <!-- 关联的公网IP -->
    <div class="el-section">
      <div class="el-section-header">
        <h3 class="el-section-title">{{$t('bwTraffic.relateIP')}}</h3>
      </div>
      <div class="el-section-content">
        <el-table :data="trafficInfo.relatedIp"
                  style="width: 100%">
          <el-table-column :label="$t('bwTraffic.IPAddress')"
                           prop="cidrAddr"></el-table-column>
          <el-table-column :label="$t('bwTraffic.lineType')"
                           prop="lineType">
                           <template slot-scope="scope">
                  <span >{{trafficInfo.lineTypeName}}</span>
                </template></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      filterEmptyFlag: false
    };
  },
  created () {

  },
  mounted () {

  },
  computed: {
    trafficInfo () {
      return this.info;
    },
    filterList () {
      return this.$store.state.filter.filterList;
    },
    alarmStatusFilters () {
      return this.filterList.alarmStatus;
    }
  },
  filters: {
    falseData (value) {
      if (value === '' || value === undefined) return '--';
      return `${value}Mbps`;
    }
  },
  methods: {
    filtersMethod (value, row) {
      console.log(value);
      if (row.alarmStatus === value) {
        return true;
      } return false;
    },
    filterChange () {
      this.filterEmptyFlag = this.$refs.filterTable.store.states.data.length === 0;
    }
  },
  props: {
    info: {
      type: Object,
      default: () => { },
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.jc-trafficInfo-container {
  // 设置footer分页(勿动)
  height: 100%;
  overflow: auto;
  .base-info-item .item {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .alarm-normall {
    color: green;
  }
  .alarm-unnormall {
    color: red !important;
  }
  .my-table-empty-block {
    width: calc(100% - 2px);
    border: 1px solid #d9e1e9;
  }
  .el-section-content{
    margin:20px 12px 20px;
  }
  .el-section+.el-section {
      border-top: 1px dotted #d9e1e9;
      padding-top: 20px;
      margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bandwidthTraffic/opt/TrafficInfo.vue